import { render, staticRenderFns } from "./needs-analysis.vue?vue&type=template&id=05232654&scoped=true&"
import script from "./needs-analysis.vue?vue&type=script&lang=js&"
export * from "./needs-analysis.vue?vue&type=script&lang=js&"
import style0 from "./needs-analysis.vue?vue&type=style&index=0&id=05232654&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05232654",
  null
  
)

export default component.exports